import styled from "styled-components";
import theme from "../../../theme";

const Container = styled.div`
  min-height: 80vh;
  background: ${theme.colors.primary};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4rem 2rem;
  color: white;
`;

const Title = styled.h1`
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  text-align: center;
  margin-bottom: 1rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const Subtitle = styled.p`
  font-size: 1.25rem;
  text-align: center;
  max-width: 800px;
  margin-bottom: 4rem;
  opacity: 0.9;
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  width: 100%;
  max-width: 1200px;
`;

const FeatureCard = styled.div`
  background: rgba(255, 255, 255, 0.95);
  border-radius: 1rem;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: transform 0.2s ease-in-out;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-4px);
  }
`;

const IconWrapper = styled.div`
  background-color: ${(props) => props.color};
  padding: 0.75rem;
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FeatureText = styled.span`
  color: #1e293b;
  font-weight: 600;
  font-size: 1.125rem;
`;

const SC = {
  Container,
  Title,
  Subtitle,
  FeaturesGrid,
  FeatureCard,
  IconWrapper,
  FeatureText,
};

export default SC;
